<script setup lang="ts">
  import CyberSecurityModal from '@/entities/Flow/components/CyberSecurityModal/CyberSecurityModal.vue'
  import { ref } from 'vue'
  import type {
    Emits,
    Props,
  } from '@/entities/Flow/components/CyberSecurityModal/CyberSecurityModal.types'
  import { useGoogleAnalytics } from '@/shared/composables'
  import { useRoute } from 'vue-router'
  import type { AvailableFlowRoutes } from '@/shared/types/flow.types'

  const props = withDefaults(defineProps<Props>(), {
    isAddButtonShown: false,
    cyberState: false,
  })

  const emit = defineEmits<Emits>()

  const gaService = useGoogleAnalytics()
  const route = useRoute()

  const isCyberSecurityOpened = ref(false)

  const openCyberSecurityModal = () => {
    if (props.quoteId) {
      gaService.sendClickLearnMore(route.name as AvailableFlowRoutes, {
        quote_id: props.quoteId,
        state: props.cyberState,
        cover_name: 'cyber_security',
      })
    } else {
      gaService.sendClickLearnMore(route.name as AvailableFlowRoutes, {
        cover_name: 'cyber_security',
      })
    }
    isCyberSecurityOpened.value = true
  }

  const onAddCyberCover = () => {
    emit('add-cyber-cover')
    isCyberSecurityOpened.value = false
  }
</script>

<template>
  <button class="flow-quote_cyber-modal" @click="openCyberSecurityModal">
    {{ $t('outbound.addon.learn_more') }}
  </button>

  <CyberSecurityModal
    v-model="isCyberSecurityOpened"
    :is-add-button-shown="props.isAddButtonShown"
    :quote-id="quoteId"
    :cyber-state="cyberState"
    @add-cyber-cover="onAddCyberCover"
  />
</template>

<style scoped lang="scss">
  .flow-quote_cyber-modal {
    color: #5927ff;
    cursor: pointer;
    background: none;
  }
</style>
